"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var isNode = require("detect-node");
var BrowserLogger_1 = require("./BrowserLogger");
var NodeLogger_1 = require("./NodeLogger");
// eslint-disable-next-line @typescript-eslint/no-redeclare
exports.Logger = isNode ? NodeLogger_1.NodeLogger : BrowserLogger_1.BrowserLogger;
//# sourceMappingURL=Logger.js.map